import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/services/ai-pentesting/page.tsx");
